import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { createRaiseOutbound } from '../../../../api/outbound/pokerOutbounds';
import { ScaledTextButton } from '../../../../components/scaledTextButton';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { getChipsDisplayStr } from '../../../../utils/chipsDisplayUtils';
function getActionLabel(betSliderAmount, isSliderAtMax, myNumChips) {
    if (!isSliderAtMax) {
        return 'RAISE TO';
    }
    if (betSliderAmount >= myNumChips) {
        return 'ALL-IN';
    }
    return 'BET POT';
}
export const DomRaiseButton = ({ betSliderAmount, bounds, myTurnProperties, showChipsAsBbMultiple, bigBlind }) => {
    const socketSend = useSocketSend();
    const onClickRaise = useCallback(() => {
        const raiseAmountForOutbound = betSliderAmount - (myTurnProperties.betTotalAmountToCall - myTurnProperties.myTotalBetAmount);
        socketSend(createRaiseOutbound(myTurnProperties.betSequenceNumber, raiseAmountForOutbound));
    }, [
        betSliderAmount,
        myTurnProperties.betSequenceNumber,
        myTurnProperties.betTotalAmountToCall,
        myTurnProperties.myTotalBetAmount,
        socketSend
    ]);
    const isSliderAtMax = betSliderAmount >= myTurnProperties.betSliderMaxAmount;
    const label = useMemo(() => getActionLabel(betSliderAmount, isSliderAtMax, myTurnProperties.myNumChips), [betSliderAmount, isSliderAtMax, myTurnProperties.myNumChips]);
    const subLabel = useMemo(() => getChipsDisplayStr({
        numChips: betSliderAmount + myTurnProperties.myNumChipsThisPhase,
        showChipsAsBbMultiple,
        bigBlind,
        truncateZeroDecimals: false
    }), [betSliderAmount, myTurnProperties.myNumChipsThisPhase, showChipsAsBbMultiple, bigBlind]);
    const { x, y, w, h } = bounds;
    return (_jsx(ScaledTextButton, { onClick: onClickRaise, label: label, subLabel: subLabel, testId: 'raise', x: x, y: y, w: w, h: h, accentColor: 'green' }));
};
